module.exports = __webpack_public_path__ + "images/emoji/thumbsup.0f835ee6eaa6708bb927.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/thumbsup.png
// module id = 2eh6
// module chunks = 24